// Admin navigation. `section`: permission section of the entry (see
// utils/roles.js), `level`: level required ("view" by default, "edit" for
// creation pages). Children inherit their parent's section unless they define
// their own; a group is shown when at least one child is. `match`: path
// prefixes that mark a group as active (detail and edit pages of the section).
// `hidden`: entry kept but not shown (Podcast, Live TV channels and Broadcast are hidden for now).

export const MENU = [
  {
    label: "Dashboard",
    icon: "ri-dashboard-line",
    path: "/dashboard",
    exact: true,
    section: "dashboard",
  },
  {
    label: "Video",
    icon: "ri-film-line",
    section: "videos",
    match: [
      "/dashboard/add-video",
      "/dashboard/video-list",
      "/dashboard/update-video",
      "/dashboard/video-info",
    ],
    children: [
      { label: "Add Video", path: "/dashboard/add-video", level: "edit" },
      { label: "Video List", path: "/dashboard/video-list" },
    ],
  },
  {
    label: "TV shows",
    icon: "ri-tv-2-line",
    section: "series",
    match: [
      "/dashboard/add-show",
      "/dashboard/show-list",
      "/dashboard/update-show",
      "/dashboard/show-info",
      "/dashboard/episode-list",
      "/dashboard/episode-info",
    ],
    children: [
      { label: "Add Show", path: "/dashboard/add-show", level: "edit" },
      { label: "Show List", path: "/dashboard/show-list" },
    ],
  },
  {
    label: "Podcast",
    hidden: true, // masqué du menu (la page et les données restent)
    icon: "ri-mic-line",
    section: "podcasts",
    match: [
      "/dashboard/add-podcast",
      "/dashboard/podcast-list",
      "/dashboard/podcast-distribution",
      "/dashboard/update-podcast",
      "/dashboard/podcast-info",
      "/dashboard/podcast-episode",
    ],
    children: [
      { label: "Add Podcast", path: "/dashboard/add-podcast", level: "edit" },
      {
        label: "Distribution",
        path: "/dashboard/podcast-distribution",
        level: "edit",
      },
      { label: "Podcast List", path: "/dashboard/podcast-list" },
    ],
  },
  {
    label: "Live TV channels",
    hidden: true, // masqué du menu (la page et les données restent)
    icon: "ri-signal-tower-line",
    section: "channels",
    match: [
      "/dashboard/add-channel",
      "/dashboard/channel-list",
      "/dashboard/update-channel",
    ],
    children: [
      { label: "Add Channel", path: "/dashboard/add-channel", level: "edit" },
      { label: "Channels List", path: "/dashboard/channel-list" },
    ],
  },
  {
    label: "Lives",
    icon: "ri-broadcast-line",
    path: "/dashboard/lives",
    section: ["channels", "dashboard", "analytics"],
  },
  {
    label: "Category",
    icon: "ri-price-tag-3-line",
    section: "categories",
    match: [
      "/dashboard/add-genre",
      "/dashboard/category-list",
      "/dashboard/update-category",
    ],
    children: [
      { label: "Add Category", path: "/dashboard/add-genre", level: "edit" },
      { label: "Categories", path: "/dashboard/category-list" },
    ],
  },
  {
    label: "Sliders",
    icon: "ri-slideshow-3-line",
    path: "/dashboard/sliders",
    section: "sliders",
  },
  {
    label: "Video performance",
    icon: "ri-bar-chart-2-line",
    path: "/dashboard/video-performance",
    section: ["videos", "analytics", "dashboard"],
  },
  {
    label: "Stats by rubric",
    icon: "ri-pie-chart-2-line",
    path: "/dashboard/category-stats",
    section: ["videos", "analytics", "dashboard", "categories"],
  },
  {
    label: "Comments",
    icon: "ri-chat-3-line",
    path: "/dashboard/comments",
    section: "comments",
  },
  {
    label: "Ads",
    icon: "ri-coupon-3-line",
    section: "ads",
    match: [
      "/dashboard/create-ads",
      "/dashboard/ads-list",
      "/dashboard/update-ad",
      "/dashboard/ad-info",
    ],
    children: [
      { label: "Create Ads", path: "/dashboard/create-ads", level: "edit" },
      { label: "Ads List", path: "/dashboard/ads-list" },
    ],
  },
  {
    label: "Notifications",
    icon: "ri-notification-3-line",
    path: "/dashboard/notifications",
    section: "notifications",
  },
  {
    label: "Broadcast",
    hidden: true, // masqué du menu (la page et les données restent)
    icon: "ri-broadcast-line",
    section: "broadcast",
    match: [
      "/dashboard/new-broadcast",
      "/dashboard/my-broadcast",
      "/dashboard/broadcast-info",
    ],
    children: [
      { label: "New Broadcast", path: "/dashboard/new-broadcast" },
      { label: "My Broadcasts", path: "/dashboard/my-broadcast" },
    ],
  },
  {
    label: "Mobile app",
    icon: "ri-smartphone-line",
    path: "/dashboard/mobile-app",
    section: "mobile_app",
  },
  {
    label: "Users",
    icon: "ri-group-line",
    path: "/dashboard/user-list",
    match: ["/dashboard/user-list", "/dashboard/user-info"],
    section: "users",
  },
  {
    label: "Most active users",
    icon: "ri-fire-line",
    path: "/dashboard/active-users",
    section: "users",
  },
  {
    label: "Subscribers to win back",
    icon: "ri-user-received-line",
    path: "/dashboard/win-back",
    section: "users",
  },
  {
    label: "Game (quiz)",
    icon: "ri-trophy-line",
    path: "/dashboard/quiz",
    section: "quiz",
  },
  {
    label: "Analytics",
    icon: "ri-bar-chart-2-line",
    path: "/dashboard/analytics",
    section: "analytics",
  },
  {
    label: "Payments",
    icon: "ri-money-dollar-circle-line",
    path: "/dashboard/payments",
    section: "transactions",
  },
  {
    label: "Revenue",
    icon: "ri-funds-line",
    path: "/dashboard/revenue",
    section: "transactions",
  },
  {
    label: "Unpaid reminders",
    icon: "ri-mail-send-line",
    path: "/dashboard/unpaid-reminders",
    section: "transactions",
  },
  {
    label: "Payment Gateway",
    icon: "ri-bank-card-line",
    path: "/dashboard/payment-gateway",
    section: "payments",
  },
  {
    label: "Subscription plan",
    icon: "ri-vip-crown-line",
    path: "/dashboard/package",
    section: "plans",
  },
  {
    label: "Administrators",
    icon: "ri-shield-user-line",
    path: "/dashboard/admin-list",
    section: "admins",
  },
  {
    label: "Legal Information",
    icon: "ri-information-line",
    section: "legal",
    children: [
      { label: "Privacy Policy", path: "/dashboard/privacy-policy" },
      {
        label: "Terms and Conditions",
        path: "/dashboard/terms-and-conditions",
      },
      { label: "About Us", path: "/dashboard/about-us" },
      { label: "Social Channels", path: "/dashboard/social-channels" },
      { label: "FAQS", path: "/dashboard/faqs", section: "faqs" },
    ],
  },
  {
    label: "Main Menu",
    icon: "ri-route-line",
    path: "/dashboard/routes-permission",
    section: "app_menu",
  },
  {
    // Not a permission section: only system and super admins (see utils/roles.js `can`).
    label: "Maintenance",
    icon: "ri-settings-3-line",
    path: "/dashboard/maintenance",
    section: "maintenance",
  },
  {
    // Logs section, or the admin activity alone for admins who manage administrators
    label: "Audit and logs",
    icon: "ri-file-list-2-line",
    path: "/dashboard/logs",
    section: ["logs", "admins"],
  },
  {
    label: "Incidents",
    icon: "ri-alarm-warning-line",
    path: "/dashboard/incidents",
    section: "logs",
  },
  {
    label: "Emails sent",
    icon: "ri-mail-check-line",
    path: "/dashboard/emails",
    section: ["users", "logs"],
  },
];

/**
 * Menu entries (and children) allowed by `can(section, level)`. A group is
 * kept when at least one of its children is.
 */
export function visibleMenu(can, menu = MENU) {
  return menu
    .filter((item) => !item.hidden)
    .map((item) => {
      if (!item.children) {
        const sections = [].concat(item.section);
        return sections.some((section) => can(section, item.level || "view")) ? item : null;
      }
      const children = item.children.filter((child) =>
        can(child.section || item.section, child.level || "view")
      );
      return children.length ? { ...item, children } : null;
    })
    .filter(Boolean);
}

/** First page the admin can open (after login, or when a page is refused). */
export function firstAllowedPath(can, menu = MENU) {
  for (const item of visibleMenu(can, menu)) {
    const target = item.path || item.children?.[0]?.path;
    if (target) return target;
  }
  return "/dashboard/profile";
}

const startsWith = (pathname, prefix) =>
  pathname === prefix || pathname.startsWith(prefix + "/");

/** Whether a menu entry (or one of its children) matches the current path. */
export function isActive(item, pathname) {
  if (item.exact) return pathname === item.path;
  const prefixes = [
    item.path,
    ...(item.match || []),
    ...(item.children || []).map((c) => c.path),
  ].filter(Boolean);
  return prefixes.some((prefix) => startsWith(pathname, prefix));
}
